"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreferencesTypeEnum = void 0;
/**
 * The preference type for a set of preferences.
 *
 * Each preference type is resolved in order of specificity,
 * with 1 being the most specific and 4 being the least specific.
 *
 * 1. `SUBSCRIBER_WORKFLOW` - The subscriber's preference for a workflow.
 * 2. `SUBSCRIBER_GLOBAL` - The subscriber's global preference.
 * 3. `USER_WORKFLOW` - The user's preference for a workflow.
 * 4. `WORKFLOW_RESOURCE` - The Framework-defined preference for a workflow.
 */
var PreferencesTypeEnum;
(function (PreferencesTypeEnum) {
    PreferencesTypeEnum["SUBSCRIBER_WORKFLOW"] = "SUBSCRIBER_WORKFLOW";
    PreferencesTypeEnum["SUBSCRIBER_GLOBAL"] = "SUBSCRIBER_GLOBAL";
    PreferencesTypeEnum["USER_WORKFLOW"] = "USER_WORKFLOW";
    PreferencesTypeEnum["WORKFLOW_RESOURCE"] = "WORKFLOW_RESOURCE";
})(PreferencesTypeEnum || (exports.PreferencesTypeEnum = PreferencesTypeEnum = {}));
//# sourceMappingURL=workflow-channel-preferences.js.map